import styled from 'styled-components';

export const CheckIconContainer = styled.span`
  color: ${({ theme }) => theme.palette.primaryExtended.opacityBackgroundText};
  line-height: 62.5%;
`;

export const LabelWithInfo = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const InfoIconContainer = styled.span`
  display: inline-flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.text.secondary};
  cursor: help;
  line-height: 62.5%;
`;
